import { Stack, Title } from '@mantine/core';
import { CurrentSubscription } from '../../../components/Billing/CurrentSubscription';
import { SubscriptionPlans } from '../../../components/Billing/SubscriptionPlans';
import { PageHeader } from '../../../components/Common/PageHeader';

export function AccountBillingSubscriptionsPage() {
  return (
    <>
      <PageHeader
        title="Subscriptions"
        subtitle="Manage your plan or switch tiers — pay-as-you-go remains available alongside any subscription."
      />
      <Stack>
        <CurrentSubscription />
        <Title order={3} fw={600}>
          Subscription Plans
        </Title>
        <SubscriptionPlans />
      </Stack>
    </>
  );
}
